export default __webpack_public_path__ + "static/media/243c5983-e932-435d-9798-3aa696bcdf8f.e13a845c.jpg";